import {
  ApplicationConfig,
  importProvidersFrom,
  Injector,
  provideZoneChangeDetection,
} from '@angular/core';
import { provideRouter, Router } from '@angular/router';
import { routes } from '@app/app.routes';
import {
  provideHttpClient,
  withFetch,
  withInterceptors,
} from '@angular/common/http';
import { OktaAuthModule } from '@okta/okta-angular';
import { OktaAuth } from '@okta/okta-auth-js';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import oktaConfigFile from '@app/okta.config';
import { AuthInterceptor } from '@services/auth/auth.interceptor';

export const appConfig: ApplicationConfig = {
  providers: [
    importProvidersFrom(
      OktaAuthModule.forRoot({
        oktaAuth: new OktaAuth({
          issuer: oktaConfigFile.oidc.issuer,
          clientId: oktaConfigFile.oidc.clientId,
          redirectUri: oktaConfigFile.oidc.oktaRedirectUri,
          scopes: oktaConfigFile.oidc.scopes,
          // storageManager: {
          //   token: {
          //     storageTypes: ['memory'],
          //   },
          // },
        }),
        onAuthRequired: (oktaAuth: any, injector: Injector) => {
          const router = injector.get(Router);
          router.navigate(['/login']);
        },
      }),
    ),
    provideZoneChangeDetection({ eventCoalescing: true }),
    provideRouter(routes),
    provideHttpClient(withInterceptors([AuthInterceptor]), withFetch()),
    provideAnimationsAsync(),
  ],
};
